module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/long_arrow-46659412d32accff8d3c6c98549eaa62.svg";